<template>
	<view class="box">
		<view class="box_head">
			<image src="@/static/logo@2x.png" mode="widthFix"></image>
			<text class="box_head_a">访客预约待审核</text>
			<text class="box_head_b">您的预约单已提交审核，请等待被访人审核</text>
		</view>
		<view class="box_list">
			<view class="box_list_label">拜访信息</view>
			<view class="box_list_item">
				<view class="box_list_item_label">拜访员工：</view>
				<view class="box_list_item_val">马梓龙</view>
			</view>
			<view class="box_list_item">
				<view class="box_list_item_label">拜访事由：</view>
				<view class="box_list_item_val">洽谈业务</view>
			</view>
			<view class="box_list_item">
				<view class="box_list_item_label">拜访时间：</view>
				<view class="box_list_item_val">2023-11-10 09:03 至2023-11-10 11:00</view>
			</view>
			<view class="box_list_item">
				<view class="box_list_item_label">访问门禁：</view>
				<view class="box_list_item_val">门禁1、门禁2</view>
			</view>
			<view class="box_list_item">
				<view class="box_list_item_label">随访人员1：</view>
				<view class="box_list_item_val">李自力 1885512677</view>
			</view>
			<view class="box_list_item">
				<view class="box_list_item_label">随访人员2：</view>
				<view class="box_list_item_val">王瑶 1385512677</view>
			</view>
		</view>
	</view>
</template>

<script>
	export default {
		data() {
			return {
				
			};
		}
	}
</script>
<style>
	page {
		background-color: #f7f7f7;
	}
</style>
<style lang="scss" scoped>
	.box {
		width: 100%;
		.box_head {
			width: 100%;
			padding: 40rpx 0;
			box-sizing: border-box;
			background-color: #ffffff;
			display: flex;
			align-items: center;
			justify-content: center;
			flex-direction: column;
			image {
				width: 320rpx;
				height: 320rpx;
			}
			.box_head_a {
				font-size: 36rpx;
				font-weight: 600;
				color: #025EEF;
				margin-top: 30rpx;
			}
			.box_head_b {
				font-size: 26rpx;
				font-weight: 400;
				color: #666666;
				margin-top: 24rpx;
			}
		}
		.box_list {
			width: 100%;
			margin-top: 20rpx;
			background-color: #ffffff;
			padding: 40rpx 30rpx;
			box-sizing: border-box;
			.box_list_label {
				font-size: 32rpx;
				font-weight: 500;
				color: #222222;
			}
			.box_list_item {
				width: 100%;
				display: flex;
				align-items: center;
				margin-top: 30rpx;
				.box_list_item_label {
					font-size: 28rpx;
					font-family: PingFangSC, PingFang SC;
					font-weight: 400;
					color: #666666;
				}
				.box_list_item_val {
					font-size: 28rpx;
					font-family: PingFangSC, PingFang SC;
					font-weight: 400;
					color: #333333;
				}
			}
		}
	}
</style>
